import api from '@services/api.service'
import { createAsyncThunk } from '@reduxjs/toolkit'
import { authorUrl } from '@store/slices/author.slice'
import { AxiosError } from 'axios'
import { DjangoErrorResponse } from '@store/slices/generic.slice'
import { toast } from 'react-toastify'

export const fetchAllAuthors = createAsyncThunk('author/fetchAll', async () => {
  try {
    const response = await api.get(`${authorUrl}`)
    return response.data
  } catch (error) {
    const axiosError = error as AxiosError
    if (axiosError.response) {
      const serverError = axiosError.response.data as DjangoErrorResponse
      toast.error(`${serverError.message || 'Nepodařilo se načíst playlist'}`)
    } else {
      toast.error('Nepodařilo se načíst playlist')
    }
    throw axiosError
  }
})
